import immutable from 'immutable';
import {KEYWORD_TOPIC} from 'utils/const';

const SavedSearch = immutable.Record({
  id: '',
  user_id: '',
  permalink: '',
  title: '',
  data: immutable.Map(),
  state: immutable.Map(),
});

const createSavedSearchFromServerObject = obj => {
  return new SavedSearch({
    id: obj.id,
    user_id: obj.user_id,
    permalink: obj.permalink,
    title: obj.title,
    data: immutable.fromJS(obj.data), // Map
    state: handleState(obj.state), // Map
  });
};

function handleState(state) {
  // Stupidly, the search widgets expect a whole lot of immutability, but not for values.
  let thing = immutable
    .fromJS(state) // Map
    .map(field => makeValuesMutable(field));

  // Also stupidly, there's some mismatch with keyword/topic conditions.
  const kw = thing.get(KEYWORD_TOPIC);
  if (kw) {
    thing = thing.set(KEYWORD_TOPIC, makeConditionsMutable(kw));
  }
  return thing;
}

function makeValuesMutable(field) {
  const values = field.get('values');
  if (values) {
    return field.set('values', values.toJS());
  }
  return field;
}

function makeConditionsMutable(field) {
  const conditions = field.get('conditions');
  if (conditions) {
    return field.set('conditions', conditions.toJS());
  }
  return field;
}

export {createSavedSearchFromServerObject};
export default SavedSearch;
